import { render } from "./KnowledgeRecycleBin.vue?vue&type=template&id=9b27ff46&scoped=true"
import script from "./KnowledgeRecycleBin.vue?vue&type=script&lang=js"
export * from "./KnowledgeRecycleBin.vue?vue&type=script&lang=js"

import "./KnowledgeRecycleBin.vue?vue&type=style&index=0&id=9b27ff46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b27ff46"]])

export default __exports__